import { render, staticRenderFns } from "./ShoppingBasket.vue?vue&type=template&id=69e931e6&scoped=true&"
import script from "./ShoppingBasket.vue?vue&type=script&lang=js&"
export * from "./ShoppingBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e931e6",
  null
  
)

export default component.exports